import { z } from 'zod';

export const policyTypeSchema = z.enum(['TERMS_OF_SERVICE', 'PRIVACY_POLICY', 'EULA']);

export const acceptanceMethodSchema = z.enum(['REGISTRATION', 'LOGIN_GATE', 'EXPLICIT_REVIEW']);

export const policyVersionWireSchema = z.object({
  id: z.string(),
  policy_id: z.string(),
  version_number: z.number().int(),
  effective_date: z.string(),
  content_r2_key: z.string(),
  content_hash: z.string(),
  requires_acceptance: z.number().int(),
  change_summary: z.string().nullable(),
  published_by: z.string(),
  published_at: z.string(),
});

export const activePolicyWireSchema = z.object({
  id: z.string(),
  type: policyTypeSchema,
  current_version: policyVersionWireSchema.nullable(),
});

export const activePoliciesResponseWireSchema = z.object({
  policies: z.array(activePolicyWireSchema),
});

export const unacceptedPolicyWireSchema = z.object({
  policy_id: z.string(),
  policy_type: policyTypeSchema,
  version_id: z.string(),
  version_number: z.number().int(),
  effective_date: z.string(),
  content_r2_key: z.string(),
  change_summary: z.string().nullable(),
});

export const unacceptedPoliciesResponseWireSchema = z.object({
  policies: z.array(unacceptedPolicyWireSchema),
  is_first_acceptance: z.boolean(),
});

export const policyContentWireSchema = z.object({
  content: z.string(),
  content_hash: z.string(),
});

export const userPolicyAcceptanceWireSchema = z.object({
  id: z.string(),
  user_id: z.string(),
  policy_version_id: z.string(),
  accepted_at: z.string(),
  ip_address: z.string(),
  user_agent: z.string(),
  acceptance_method: acceptanceMethodSchema,
});

export type PolicyType = z.infer<typeof policyTypeSchema>;
export type AcceptanceMethod = z.infer<typeof acceptanceMethodSchema>;
export type PolicyVersionWire = z.infer<typeof policyVersionWireSchema>;
export type ActivePolicyWire = z.infer<typeof activePolicyWireSchema>;
export type ActivePoliciesResponseWire = z.infer<typeof activePoliciesResponseWireSchema>;
export type UnacceptedPolicyWire = z.infer<typeof unacceptedPolicyWireSchema>;
export type UnacceptedPoliciesResponseWire = z.infer<typeof unacceptedPoliciesResponseWireSchema>;
export type PolicyContentWire = z.infer<typeof policyContentWireSchema>;
export type UserPolicyAcceptanceWire = z.infer<typeof userPolicyAcceptanceWireSchema>;
